import React, { FunctionComponent } from "react";
import { View, Text } from "@react-pdf/renderer";

import { DetailedCartItem } from "../../../../context/CartContext/CartContext.api.types";
import { displayMoney } from "../../../../utils/displayMoney";

const SpecialManufacturingDisclaimer = ({}) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "baseline",
      fontSize: "8px",
      marginTop: "16px",
      width: "100%",
      fontFamily: "Mont-Regular",
    }}
  >
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        color: "black",
        width: "100%",
        textAlign: "left",
      }}
    >
      * Consultar valor de hechura de especiales
    </Text>
  </View>
);

export default SpecialManufacturingDisclaimer;
